/* istanbul ignore file */
import '../../legacy/scss/main_mowiztruck.scss'
import '@elparking/icons'
